export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Route/GProuteOpen.png?3575bc3b3d67986648508488eead0a64";